export const API_ERROR = new Map([
    [ 32, 'Impossible de vous identifier' ],
    [ 52, 'Erreur lors de la mise à jour du profil' ],
]);
